import React from 'react';
import 'react-pivottable/pivottable.css';
import {
  TextField,
  MenuItem,
  Checkbox,
  ListItemText,
  Chip,
  Button,
} from '@material-ui/core';
import { css } from '@emotion/core';
import { FormRow } from '../../styles/styles';
import SimpleSelect from '../../util/SimpleSelect';
import RenderPropModal from '../../dealMapper/common/RenderPropModal';

const FilterContainer = css`
  display: flex;
  flex: 1;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  max-width: 500px;
  width: 100%;
`;

const ButtonRow = css`
  display: flex;
  justify-content: flex-end;
  margin-top: 0.5rem;
  button {
    margin-right: 5px;
  }
`;

const DealTranFilters = ({
  values,
  handleBlur,
  handleChange,
  dirty,
  resetForm,
  hasChanged,
  getReport,
  initialValues,
}) => {
  return (
    <RenderPropModal
      cardDisplay={({ handleClose }) => (
        <div css={FilterContainer}>
          <FormRow>
            <TextField
              name="endDate"
              label="Before Date"
              margin="normal"
              value={values.endDate}
              onChange={handleChange}
              onBlur={handleBlur}
              variant="outlined"
              type="date"
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
            />
            <TextField
              name="startDate"
              label="After Date"
              margin="normal"
              value={values.startDate}
              onChange={handleChange}
              onBlur={handleBlur}
              variant="outlined"
              type="date"
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
            />
          </FormRow>
          <div css={ButtonRow}>
            <Button
              color="primary"
              variant="contained"
              disabled={!dirty}
              onClick={() => {
                getReport();
                resetForm(values);
                handleClose();
              }}
            >
              Apply to Report
            </Button>
            <Button
              color="primary"
              variant="contained"
              disabled={!hasChanged}
              onClick={() => {
                resetForm(initialValues);
                getReport(initialValues);
              }}
            >
              Reset Changes
            </Button>
          </div>
        </div>
      )}
    >
      {({ handleOpen }) => (
        <Button
          onClick={handleOpen}
          variant="outlined"
          color={hasChanged ? 'primary' : 'default'}
        >
          Report Filters
        </Button>
      )}
    </RenderPropModal>
  );
};

export default DealTranFilters;
